import React from "react";
import abouthome from "../../images/abouthome.png";

const HomeAbout = () => {
  return (
    <div className="home-about mt-5 pt-5 mb-5 pb-5">
      <div className="container">
        <div className="row home-about-wrap">
          <div className="col-lg-6">
            <img className="about-image" src={abouthome} alt="" />
          </div>
          <div className="col-lg-6">
            <div className="home-about-right d-flex flex-column justify-content-center h-100">
              <div className="label-head ">--  About Us  --</div>
              <h1>
                Turning <span className="color-primary ">Tour Dream Home </span>{" "}
                into Reality
              </h1>
              <p>
                About Us <br />
                At AFS DOTE, we specialize in transforming spaces into timeless
                works of art. Our expertise spans interior design, architecture,
                landscape design, and luxury furniture, creating seamless,
                sophisticated environments that reflect your unique vision. From
                concept to completion, we blend innovative design, premium
                materials, and meticulous craftsmanship to deliver bespoke
                solutions tailored to your lifestyle. Whether it's redefining
                interiors, crafting architectural masterpieces, curating outdoor
                landscapes, or furnishing with elegance, we bring a harmonious
                balance of form, function, and luxury to every project. Let us
                help you create spaces that inspire and elevate everyday living.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeAbout;
